import { render, staticRenderFns } from "./RecruitmentCenter.vue?vue&type=template&id=dc699748&scoped=true&"
import script from "./RecruitmentCenter.vue?vue&type=script&lang=js&"
export * from "./RecruitmentCenter.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentCenter.vue?vue&type=style&index=0&id=dc699748&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc699748",
  null
  
)

export default component.exports